import axios from 'axios';
const VUCalls = {};

VUCalls.setup = () =>{

    return axios.create({
        baseURL: localStorage.getItem('url'),
        headers: {
            uuid: localStorage.getItem('uuidbb')
        }
    });
}
VUCalls.operationSave = ( id, VUCallsRequest) => {
    console.log(id);
    const client = VUCalls.setup();
    if(id){
        return client.put('/api/vu/newOperation' + id, {VUCallsRequest});
    }
    return client.post('/api/vu/newOperation', VUCallsRequest);
}

export { VUCalls };


// WEBPACK FOOTER //
// ./src/components/OnBoarding/services/VuService.js